import { Injectable }     from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { Observable }     from '../../../node_modules/rxjs/Observable';
import { Order } from '../entities/order';
import { Company } from '../entities/company';
import { Customer } from '../entities/customer';

import { SERVER_URL } from './server-url';
import { Delivery } from '../entities/delivery';
import { Product } from '../entities/product';

@Injectable()   
export class OrderService {
    
    private orderUrl = SERVER_URL + '/api/orders';  // URL to web API
    //private trackerUrl = 'http://104.198.40.29:3005/api/delivery';  // URL to web API
    //private trackerUrl = 'http://localhost:3005/api/delivery';  // URL to web API
    //private trackerUrl = 'http://192.168.15.8:3005/api/delivery';  // URL to web API
    
    public orders:Array<Order>;

    constructor (private http: Http) {}

    getOrders(tokenLogged:string): Observable<Order[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.get(this.orderUrl, {headers: headers})
                    .map(this.extractOrdersFromJSON)
                    .catch(this.handleError);
    }
    
    private extractOrdersFromJSON(res: Response | any) {
        let body = res.json();
        var ordersList:Order[] = []; 

        for (let entry of body) {
            if (!entry.id) { return; }

            var order:Order = new Order(entry.id, entry.dt_order, 
                new Company(entry.company_id, entry.company_name, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, entry.company_tel, null, entry.company_email, null, null, null,null,null,null,null,null,null,null,null,null,null, entry.company_time_discharge, null, entry.customer_id, null, null,null), 
                new Customer(entry.customer_id, null, null, null, null), 
                entry.products, 
                entry.delivery_address,
                entry.delivery_number,
                entry.delivery_complement, 
                entry.delivery_neighborhood, 
                entry.delivery_city,
                entry.delivery_state, 
                entry.delivery_country, 
                entry.delivery_zipcode,
                entry.delivery_lat,
                entry.delivery_lng,
                entry.payment_method,
                new Delivery(entry.delivery_id, null, null, null, null, null, null, null, null, null, null , null, null, null, null),
                entry.delivery_sort,
                entry.total_price, 
                entry.total_weight,
                entry.total_quantity,
                entry.id_external);
                    
            ordersList.push(order);
        }
        return ordersList;
    }

    insertOrder(tokenLogged:string, order:Order): Observable<any> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.post(this.orderUrl + '/insert', order, {headers: headers})
                    .map(this.resultInsert)
                    .catch(this.handleError);
    }

    private resultInsert(res: Response | any) {
        let body = res.json();
        //console.log("retorno insert => " + body);
    }

    updateOrder(tokenLogged:string, order:Order): Observable<any> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.post(this.orderUrl + '/update', order, {headers: headers})
                    .map(this.resultInsert)
                    .catch(this.handleError);
    }

    getOrderById(tokenLogged:string, id:number): Observable<Order> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.get(this.orderUrl + '/' + id, {headers: headers})
                    .map(this.extractOrderFromJSON)
                    .catch(this.handleError);
    }

    private extractOrderFromJSON(res: Response | any) {
        let body = res.json();
        let entry = body[0];
        //console.log('entry -> ' + entry);

        if (!entry.id) { return; }

        var order:Order = new Order(entry.id, entry.dt_order, 
            new Company(entry.company_id, entry.company_name, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, entry.company_tel, null, entry.company_email, null, null, null,null,null,null,null,null,null,null,null,null,null, entry.company_time_discharge, null, entry.customer_id, null, null, null), 
            new Customer(entry.customer_id, null, null, null, null), 
            entry.products, 
            entry.delivery_address,
            entry.delivery_number,
            entry.delivery_complement, 
            entry.delivery_neighborhood, 
            entry.delivery_city,
            entry.delivery_state, 
            entry.delivery_country, 
            entry.delivery_zipcode,
            entry.delivery_lat,
            entry.delivery_lng,
            entry.payment_method,
            new Delivery(entry.delivery_id, null, null, null, null, null, null, null, null, null, null, null, null, null, null),
            entry.delivery_sort,
            entry.total_price, 
            entry.total_weight,
            entry.total_quantity,
            entry.id_external);
                                        
        return order;
    }

    getProductsByOrderId(tokenLogged:string, id:number): Observable<Array<Product>> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.get(this.orderUrl + '/' + id + '/products', {headers: headers})
                    .map(this.extractProductsFromJSON)
                    .catch(this.handleError);
    }

    private extractProductsFromJSON(res: Response | any) {
        let body = res.json();
        
        //console.log('entry -> ' + entry);
        var products:Array<Product> = [];
        
        for (let productItem of body) {
            var product:Product = new Product(productItem.product_id, null, productItem.name, productItem.weight, productItem.quantity, productItem.price);
            products.push(product);
        }
             
        return products;
    }

    deleteOrder(tokenLogged:string, order:Order) {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.post(this.orderUrl + '/deactivate', order, {headers: headers})
                    .map(this.deleteOrderExtractFromJSON)
                    .catch(this.handleError);
        
        
    }

    private deleteOrderExtractFromJSON(res: Response | any) {
        //console.log('Excluído');
        let body = res.json();
        let entry = body[0];
        //console.log('res -> ' + entry);

    }

    private handleError (error: Response | any) {
        let errMsg: string;

        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } 
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }

    static generateDate(formatDate:any):Date {
        if (formatDate && formatDate.length > 0) {
            var dd = +formatDate.slice(8,10);
            var mm = +formatDate.slice(5,7);
            var yyyy = +formatDate.slice(0,4);
            var auxDate = new Date();
            auxDate.setDate(dd);
            auxDate.setMonth(mm-1);
            auxDate.setFullYear(yyyy);

            return auxDate;
        } else {
            return null;
        }
    }
    
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/services/order.service.ts